<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>payment</mat-icon></div>
    <div class="ip-header-text">
      <h2 class="cf-dlg-title">Pagos de la inversión</h2>
      <p class="cf-dlg-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando pagos…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="savingMessage"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="ip-alert ip-alert--error">
        <mat-icon>error</mat-icon>
        <span>No se pudieron cargar los pagos de la inversión.</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body ip-body">
      <div class="ip-remaining">
        <div class="ip-remaining__left">
          <div class="ip-remaining__icon"><mat-icon>account_balance_wallet</mat-icon></div>
          <div>
            <span class="ip-remaining__label">Importe pendiente</span>
            <span class="ip-remaining__amount">{{ remaining | number:'1.2-2' }} €</span>
            <span class="ip-remaining__hint">Total {{ total | number:'1.2-2' }} € · Pagado {{ paidAmount | number:'1.2-2' }} €</span>
          </div>
        </div>
        <div class="ip-remaining__actions" *ngIf="showForm">
          <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="assignRemaining()">
            <mat-icon>check</mat-icon> Asignar pendiente
          </button>
        </div>
      </div>

      <div class="ip-section" *ngIf="isPaid && !editing">
        <div class="ip-paid">
          <mat-icon>check_circle</mat-icon>
          Inversión pagada por completo
        </div>
      </div>

      <ng-container *ngIf="showForm">
        <div class="ip-section">
          <span class="cf-dlg-section__label">
            {{ editing ? 'Editar pago' : 'Nuevo pago' }}
            <button *ngIf="editing" type="button" class="ip-link" (click)="cancelEdit()">Cancelar edición</button>
          </span>

          <div class="ip-alert ip-alert--error" *ngIf="saveError">
            <mat-icon>error</mat-icon>
            <span>{{ saveError }}</span>
          </div>

          <div class="ip-grid">
            <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingDate">
              <app-date [control]="depositDateControl" [config]="{ label: 'Fecha de pago', required: true }"></app-date>
              <div class="cf-field__error" *ngIf="submitted && missingDate"><mat-icon>error</mat-icon> Indica la fecha</div>
            </div>

            <div class="cf-field--required" [class.cf-field--invalid]="submitted && invalidAmount">
              <app-field [control]="amountControl" [config]="{ label: 'Importe', type: 'number', required: true, suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
              <div class="cf-field__error" *ngIf="submitted && invalidAmount"><mat-icon>error</mat-icon> {{ amountError }}</div>
            </div>

            <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingTypePay">
              <app-autocomplete [control]="typePayControl" [config]="methodConfig"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && missingTypePay"><mat-icon>error</mat-icon> Selecciona el tipo de pago</div>
            </div>

            <div *ngIf="typePay === methods.transfer" class="cf-field--required" [class.cf-field--invalid]="submitted && missingBankAccount">
              <app-autocomplete [control]="control('bankAccounts')" [config]="configs.bankAccounts"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && missingBankAccount"><mat-icon>error</mat-icon> Selecciona la cuenta bancaria</div>
            </div>

            <div *ngIf="typePay === methods.transfer" [class.cf-field--invalid]="submitted && invalidCommissions">
              <app-field [control]="commissionsControl" [config]="{ label: 'Comisión bancaria', type: 'number', suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
              <div class="cf-field__error" *ngIf="submitted && invalidCommissions"><mat-icon>error</mat-icon> Importe no válido</div>
            </div>

            <div *ngIf="typePay === methods.creditCard" class="cf-field--required" [class.cf-field--invalid]="submitted && missingCard">
              <app-autocomplete [control]="control('paymentCards')" [config]="configs.paymentCards"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && missingCard"><mat-icon>error</mat-icon> Selecciona la tarjeta</div>
            </div>

            <div *ngIf="typePay === methods.cash" class="cf-field--required" [class.cf-field--invalid]="submitted && missingCash">
              <app-autocomplete [control]="control('cashRegisters')" [config]="configs.cashRegisters"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && missingCash"><mat-icon>error</mat-icon> Selecciona la caja</div>
            </div>

            <div *ngIf="typePay === methods.partner" class="cf-field--required" [class.cf-field--invalid]="submitted && missingPartner">
              <app-autocomplete [control]="control('partners')" [config]="configs.partners"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && missingPartner"><mat-icon>error</mat-icon> Selecciona el socio</div>
            </div>

            <div *ngIf="typePay === methods.creditPolicy" class="cf-field--required" [class.cf-field--invalid]="submitted && missingCreditPolicy">
              <app-autocomplete [control]="control('creditPolicies')" [config]="configs.creditPolicies"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && missingCreditPolicy"><mat-icon>error</mat-icon> Selecciona la póliza</div>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="ip-section">
        <span class="cf-dlg-section__label">Pagos registrados</span>

        <div class="ip-alert" *ngIf="!deposits.length">
          <mat-icon>info</mat-icon>
          <span>Todavía no hay pagos registrados para esta inversión.</span>
        </div>

        <div class="ip-rows" *ngIf="deposits.length">
          <div class="ip-row" *ngFor="let row of deposits; trackBy: trackByUid" [class.ip-row--editing]="editing?.uid === row.uid">
            <div class="ip-row__main">
              <div class="ip-row__amount">{{ row.amount | number:'1.2-2' }} €</div>
              <div class="ip-row__meta">
                {{ row.typePay || 'Sin forma de pago' }}{{ row.bankAccountInfo ? ' · ' + row.bankAccountInfo : '' }}{{ row.commissions ? ' · Comisión ' + (row.commissions | number:'1.2-2') + ' €' : '' }}
              </div>
            </div>
            <div class="ip-row__date">{{ row.depositDate | date:'dd/MM/yyyy' }}</div>
            <div class="ip-row__actions">
              <button mat-icon-button class="ip-row__btn" (click)="startEdit(row)" title="Editar" aria-label="Editar pago">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button class="ip-row__btn ip-row__btn--danger" (click)="deleteDeposit(row)" title="Eliminar" aria-label="Eliminar pago">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button *ngIf="showForm" mat-flat-button class="cf-dlg-btn-primary" (click)="save()">
        <mat-icon>{{ editing ? 'save' : 'check_circle' }}</mat-icon> {{ editing ? 'Guardar cambios' : 'Pagar' }}
      </button>
    </div>
  </ng-container>
</div>
